import { api } from './api';
import {
  Recipe,
  RecipeWithAuthor,
  CreateRecipeInput,
  UpdateRecipeInput,
  PaginatedResponse,
} from '../Types/api';

export const recipeService = {
  list: (nextToken?: string) => {
    const params = nextToken ? `?nextToken=${encodeURIComponent(nextToken)}` : '';
    return api.get<PaginatedResponse<Recipe>>(`/recipes${params}`);
  },

  get: (id: string) => api.get<Recipe>(`/recipes/${id}`),

  create: (input: CreateRecipeInput) => api.post<Recipe>('/recipes', input),

  update: (id: string, input: UpdateRecipeInput) => api.put<Recipe>(`/recipes/${id}`, input),

  delete: (id: string) => api.delete<void>(`/recipes/${id}`),

  search: (query: string) =>
    api.get<PaginatedResponse<Recipe>>(`/recipes/search?q=${encodeURIComponent(query)}`),

  getPublic: (limit = 8) =>
    api.get<PaginatedResponse<RecipeWithAuthor>>(`/recipes/public?limit=${limit}`),

  getPublicById: (id: string) => api.get<Recipe>(`/recipes/public/${id}`),
};
